import "../../assets/scss/components/templates/navbar.scss";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Image, NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/images/logo.svg";
import menu from "../../assets/images/menu.svg";
import close from "../../assets/images/close.svg";
import resourceDropdown1 from "../../assets/images/home/resources-dropdown-icon-1.svg";
import resourceDropdown2 from "../../assets/images/home/resources-dropdown-icon-2.svg";
import resourceDropdown3 from "../../assets/images/home/resources-dropdown-icon-3.svg";

import CustomToggler from "./customToggler";
import { useState } from "react";
import Btn from "./button";
import SignupModal from "./signupModal";
import VerificationModal from "./verificationModal";
import { isTokenPresent } from "../../utils/userHelper";

function Header() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openCustomModal, setCustomModal] = useState(false);
  const [showVerificationModal, setVerificationModal] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleModal = () => {
    setCustomModal(!openCustomModal);
  };

  const handleVerificationModal = () => {
    setCustomModal(false);
    setVerificationModal(!showVerificationModal);
  };

  const clickedSignupButton = () => {
    navigate("/signup");
  };
  const clickedLoginButton = () => {
    navigate("/login");
  };
  // console.log(isTokenPresent());
  return (
    <Container className="position-relative">
      <Navbar expand="lg" expanded={open} id="navbar">
        <Container fluid>
          <Navbar.Brand href="/">
            <Image src={logo} />
          </Navbar.Brand>
          <Navbar.Toggle
            as={CustomToggler}
            iconClass={open ? close : menu}
            clas={open ? "closeIcon" : "menuIcon"}
            onClick={handleToggle}
          />
          <Navbar.Collapse className={"navbar-custom-collapse"}>
            <Nav className="mx-auto my-1 my-lg-0 ">
              <Nav.Link href="/library">Library</Nav.Link>
            </Nav>

            <Nav className="mx-auto my-2 my-lg-0">
              {isTokenPresent() ? (
                <Nav.Link
                  text="Dashboard"
                  className="collapse-item btn-outline z-2 position-relative btn btn-primary"
                  onClick={() => window.location.href=process.env.REACT_APP_APP_URL}
                >
                  Dashboard
                </Nav.Link>
              ) : (
                <>
                  <Nav.Link
                    text="Login"
                    className="collapse-item btn-outline z-2 position-relative btn btn-primary"
                    onClick={clickedLoginButton}
                  >
                    Login
                  </Nav.Link>
                  <Nav.Link
                    text="Login"
                    className="collapse-item btn-primary z-2 position-relative btn btn-primary"
                    onClick={clickedSignupButton}
                  >
                    Signup
                  </Nav.Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
          <div className="profile-dropdown ms-end">
            {isTokenPresent() ? (
              <div className="navbar-btns">
                <Btn
                  text="Dashboard"
                  class="btn-outline me-3"
                  handle={() => window.location.href=process.env.REACT_APP_APP_URL}
                />
              </div>
            ) : (
              <div className="navbar-btns">
                <Btn
                  text="Login"
                  class="btn-outline me-3"
                  handle={clickedLoginButton}
                />
                <Btn
                  text="Signup"
                  class="btn-primary"
                  handle={clickedSignupButton}
                />
              </div>
            )}
          </div>
        </Container>
        <SignupModal
          showmodal={openCustomModal}
          closemodal={handleModal}
          openVerificationModal={handleVerificationModal}
        />
        <VerificationModal
          showmodal={showVerificationModal}
          closemodal={handleVerificationModal}
        />
      </Navbar>
    </Container>
  );
}

export default Header;
